import React, { useCallback, useEffect, useState } from "react";
import ApiHelper from "../../helper/api-helper";
import ApiUrls from "../../helper/api-urls";
import { NotificationManager } from "src/util/notify";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import InputKendoRct from "../../control-components/input/input";
import { Switch } from "@progress/kendo-react-inputs";
import ErrorHelper from "../../helper/error-helper";

const FilterModel = ({ page, pageSize, finalValue, fetchFromParent, onMasterClinicIdChange, onClear,setLoading }) => {
  const [allClinic, setAllClinic] = useState([]);
  const [errors, setErrors] = useState("");
  const [staffError, ] = useState(false);

  const [fields, setFields] = useState({
    clinicId: "",
    clientId: "",
    searchContent: "",
    isActive: true,
  });

  useEffect(() => {
    getAllClinic();
  }, []);

  useEffect(() => {
    if(fields.clinicId){
      handleFilter()
    }
  }, [pageSize, finalValue])

  const getAllClinic = async () => {
    setLoading(true);
    ApiHelper.getRequest(ApiUrls.ALL_CLINIC)
      .then((result) => {
        setLoading(false);
        let staffAuditActions = result.resultData;
        setAllClinic(staffAuditActions);
      })
      .catch((error) => {
          setLoading(false);
        NotificationManager.error(error.message);
      });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setFields({
      ...fields,
      [name]: value,
    });
    if(name === "clinicId"){
    onMasterClinicIdChange(value?.id)
    }
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!fields.clinicId) {
      formIsValid = false;
      errors["clinicId"] = ErrorHelper.CLINIC_ID;
    }
    setErrors(errors);
    return formIsValid;
  };

  const handleFilter = () => {
    console.log("Adadasd")
    setLoading(true);
    if (handleValidation()) {
      const data = {
        pageNumber: (finalValue && fields.clientId === "") ? finalValue : 1,
        pageSize: pageSize,
        masterClinicId: fields.clinicId.id,
        clientId: fields.clientId === "" ? 0 : fields.clientId,
        searchContent: fields.searchContent,
        isActive: fields.isActive === false ? 0 : 1,
      };

      ApiHelper.postRequest(ApiUrls.SEARCH_CLIENT, data)
        .then((result) => {
          setLoading(false);
          fetchFromParent(result.resultData, result.metaData);
        })
        .catch((error) => {
          setLoading(false);
          NotificationManager.error(error.message);
        });
    }
  };
  const handleClear = useCallback(() => {
    setFields({
      clinicId: "",
      clientId: "",
      searchContent: "",
      isActive: false,
    });
    onMasterClinicIdChange(null);
    onClear();
  }, [onMasterClinicIdChange, onClear]);

  return (
    <>
     
      <div className="row align-items-end">
        <div className=" col-lg-3 col-md-6 col-12 edit-Service-popup">
          <DropDownKendoRct
            validityStyles={staffError}
            onChange={handleChange}
            data={allClinic}
            value={fields.clinicId}
            textField="clinicName"
            name="clinicId"
            label="Master Clinic Name"
            error={fields.clinicId === "" && errors.clinicId}
            required={true}
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12 edit-Service-popup">
          <InputKendoRct
            value={fields.clientId}
            onChange={handleChange}
            name="clientId"
            label="Client Id"
            className="form-control"
            placeholder={"Client Id"}
            type="number"
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12 edit-Service-popup">
          <InputKendoRct
            value={fields.searchContent}
            onChange={handleChange}
            name="searchContent"
            label="Client Search"
            className="form-control"
            placeholder={"Client Search"}
          />
        </div>
        <div className="col-lg-2 col-md-6 col-12 text-right justify-content-start flex-wrap d-flex align-items-center ">
          <button className="green-btn btn-primary" onClick={handleFilter}>
            Filter
          </button>
          <button className="btn ml-3" onClick={handleClear}>
            Clear
          </button>
        </div>
        <div className="col-lg-1 col-md-6 col-12 mt-3 mt-lg-0 text-left text-lg-right ">
          <Switch
            onChange={handleChange}
            checked={fields.isActive}
            name="isActive"
            onLabel={"yes"}
            offLabel={"no"}
          />
          <span className="switch-title-text fw-600 f-16 mt-3 mr-2">Active</span>
        </div>
      </div>
    </>
  );
};

export default FilterModel;
